module.exports = function(expertiseKind) {
    return {
        run() {
            $('body').on('click','.target-link',function(event) {
                event.preventDefault();
                switch($(this).data('type')) {
                    case 'expert-certificates':
                        let number = $(this).data('number');
                        let images = $('img.certificates-gallery');

                        // Фикс
                        if ($('#certificates-gallery').data('lightGallery')) {
                            $('#certificates-gallery').data('lightGallery').destroy(true);
                            $('#certificates-gallery').html('');
                        }
            
                        for (let image of images) {
                            $('#certificates-gallery').append(`<a href="${$(image).attr('src')}"></a>`);
                        }

                        if (!$('#certificates-gallery').data('lightGallery')) {
                            $('#certificates-gallery').lightGallery({
                                download: false,
                                closable: true,
                                loop: true,
                                backdropDuration: false,
                                speed: 300,
                                fullScreen: true
                            });
                        }
                            
                        $(`#certificates-gallery a:eq(${number})`).click();
                    break;

                    case 'expert-certificates-with-load':
                        // Заново инициализируем галерею документов эксперта
                        if ($('#certificates-gallery').data('lightGallery')) {
                            $('#certificates-gallery').data('lightGallery').destroy(true);
                            $('#certificates-gallery-source').html('');
                            $('#certificates-gallery').html('');
                        }

                        axios.post('/gallery_get_images', {
                            type: 'expert-certificates',
                            expert_id: $(this).data('expert_id')
                        })
                        .then((response) => {
                            if (!$('#certificates-gallery').data('lightGallery')) {
                                for (let href of response.data) {
                                    $('#certificates-gallery-source').append(`<img src="${href}" class="certificates-gallery">`);
                                }

                                let images = $('img.certificates-gallery');

                                for (let image of images) {
                                    $('#certificates-gallery').append(`<a href="${$(image).attr('src')}"></a>`);
                                }
                                $('#certificates-gallery').lightGallery({
                                    download: false,
                                    closable: true,
                                    loop: true,
                                    backdropDuration: false,
                                    speed: 300,
                                    fullScreen: true
                                });
                            }
                                
                            $(`#certificates-gallery a:eq(0)`).click();
                        });
                    break;    
                    
                    case 'examination-images':
                        let imageNumber = $(this).data('number');
                        if ($('#mobile-state').is(':hidden')) {
                            $(this).closest('.img-block').find('.position-absolute').removeClass('d-none').addClass('d-flex');
                            axios.post('/gallery_get_images', {
                                type: $(this).data('type'),
                                id: $(this).data('id')
                            })
                            .then((response) => {
                                if (response.data.length >= 1) {
                                    if ($('#cases-gallery').data('lightGallery')) {
                                        $('#cases-gallery').data('lightGallery').destroy(true);
                                    }
                                    
                                    $('#cases-gallery').html('');
                                    for (let href of response.data) {
                                        $('#cases-gallery').append(`<a href="${href}"></a>`);
                                    }
                                    
                                    $('#cases-gallery').lightGallery({
                                        download: false,
                                        closable: true,
                                        loop: true,
                                        backdropDuration: false,
                                        speed: 300,
                                        fullScreen: true
                                    });
                                    $(this).closest('.img-block').find('.position-absolute').removeClass('d-flex').addClass('d-none');
                                    if (!!!imageNumber) 
                                        $(`#cases-gallery a:first`).click();
                                    else 
                                        $(`#cases-gallery a:eq(${imageNumber+1})`).click();  
                                }
                            });
                        }
                    break;

                    case 'letters-images': {
                        let number = $(this).data('number');
                        axios.post('/gallery_get_images', {
                            type: $(this).data('type'),
                        })
                        .then(function(response) {
                            if (response.data.length >= 1) {
                                if ($('#letters-gallery').data('lightGallery')) {
                                    $('#letters-gallery').data('lightGallery').destroy(true);
                                }
                                
                                $('#letters-gallery').html('');
                                for (let href of response.data) {
                                    $('#letters-gallery').append(`<a href="${href}"></a>`);
                                }
                                
                                $('#letters-gallery').lightGallery({
                                    download: false,
                                    closable: true,
                                    loop: true,
                                    backdropDuration: false,
                                    speed: 300,
                                    fullScreen: true
                                });
                                $(`#letters-gallery a:eq(${number})`).click();
                            }
                        });
                    break;
                    }
                    case 'examination-details':
                        $(this).closest('.case').find('.img-block').find('.position-absolute').removeClass('d-none').addClass('d-flex');
                        if(expertiseKind != 'Главный сайт') {
                            axios.post('/multi_site_examination_details', {
                                id: $(this).data('id'),
                                phone: $('.phone-data').text(),
                                domain: domain
                            })
                            .then((response) => {
                                $('.case-detail-carousel').owlCarousel().trigger('destroy.owl.carousel');
                                $('#examination-details-modal').html(response.data);
                                $('.case-detail-carousel').owlCarousel({
                                    autoWidth:false,
                                    mouseDrag: false,
                                    touchDrag: true,
                                    nav: false,
                                    dots: false,
                                    loop:false,
                                    rewind: true,
                                    autoplay: false,
                                    margin: 0,
                                    responsiveRefreshRate: 200,
                                    responsive: {
                                        0: {
                                            items: 1
                                        }
                                    },
                                    thumbs: true,
                                    thumbsPrerendered: true
                                });
                                $(this).closest('.case').find('.img-block').find('.position-absolute').removeClass('d-flex').addClass('d-none');
                                $('.features-link-modal-examination .next-outer').click(function() {
                                    $('.case-detail-carousel').owlCarousel().trigger('next.owl.carousel');
                                });
                                $('.features-link-modal-examination .prev-outer').click(function() {
                                    $('.case-detail-carousel').owlCarousel().trigger('prev.owl.carousel');
                                });
                
                                $('#examination-details-modal .city-selection-modal').css('display','block');
                                $('.input-phone').mask('+7 (000) 000-00-00');
                            });
                        } else {
                            location.href = $(this).attr('href');
                        }
                        
                    break;
                }
            });
        }
    }
}
